import {
  Card,
  CardMedia,
  Container,
  makeStyles,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
} from "@material-ui/core";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Map, Marker, TileLayer } from "react-leaflet";
import { Store } from "./types";
import CloseIcon from "@material-ui/icons/Close";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

const useStyles = makeStyles((theme) => ({
  margin: {
    marginBottom: "10px",
    marginTop: "20px",
  },
  title: {
    flexGrow: 1,
    display: "block",
  },
}));

const marker = new L.Icon({
  iconUrl: icon,
  iconSize: [25, 41],
  iconAnchor: [13, 41],
  popupAnchor: [0, -45],
  shadowUrl: iconShadow,
  shadowSize: [30, 60],
  shadowAnchor: [8, 60],
});

export default function Show(
  props: Store & { handleClose: (e: React.MouseEvent<HTMLButtonElement>) => void }
) {
  const [open, setOpen] = useState("");
  const classes = useStyles();

  return (
    <div>
      <AppBar>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={props.handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            {props.title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Toolbar></Toolbar>

      <Container maxWidth="sm">
        <div>
          <Typography className={classes.margin}>
            更新日：{(props.createdTime as Date).toLocaleDateString()}
          </Typography>

          <Carousel>
            {props.images.map((i) => (
              <>
                <Card
                  style={{ height: "300px" }}
                  onClick={() => {
                    setOpen(i);
                  }}
                >
                  <CardMedia style={{ height: "300px" }} image={i}></CardMedia>
                </Card>
              </>
            ))}
          </Carousel>
          {open !== "" && (
            <Lightbox
              mainSrc={open}
              onCloseRequest={() => setOpen("")}
              reactModalStyle={{
                overlay: {
                  zIndex: 3000,
                },
              }}
            />
          )}

          <Typography className={classes.margin}>お店の場所：{props.place}</Typography>
          <Map center={[props.latitude, props.longitude]} zoom={16} style={{ height: "300px" }}>
            <TileLayer
              attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[props.latitude, props.longitude]} icon={marker}></Marker>
          </Map>
        </div>
      </Container>
    </div>
  );
}
